import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, MenuItem, Grid, Button } from "@material-ui/core";
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import { Save } from "@material-ui/icons";
import { useForm } from "../../../../hooks/useForm";
import {
  guardarDatosContables,
  obtenerDatosContables,
  fetchBancos,
  fetchCategoriasEfectores,
  fetchCondicionIva,
  obtenerDatosJudiciales,
  guardarDatosJudiciales,
} from "../../../../actions/contrataciones/contratacionesDatosContables";
import {
  CATEGORIAS_EFECTOR,
  MENU_CONTRATACIONES, SUBTIPO_EFECTORES,
} from "../../../../utils/constants";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { CONTRATACIONES_CONTABLES_PERMISOS } from "../../../../utils/permisos";
import { FetchPlazos } from "../../../../actions/contrataciones/configuraciones/abmPlazos";

const dataCuentaJudicial = (data) => ({
  idCuentaJudicial: data?.idCuentaJudicial || "",
  idBanco: data?.idBanco || "",
  idTipoCuenta: data?.idTipoCuenta || "",
  cbu: data?.cbu || "",
  alias: data?.alias || ""
})

export const DatosBancariosTab = (props) => {
  const dispatch = useDispatch();
  const {
    datosContablesExistentes,
    bancos: listaBancos,
    categorias: listaCategorias,
    condicionIva: listaIva
  } = useSelector((state) => state.contratacionesDatosBancarios);
  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { dataContrato, acuerdoJudicial } = useSelector((state) => state.contrataciones);

  const cuentaJudicial = !props.menuConsulta && acuerdoJudicial;

  let datosContablesNuevos = {
    idDatosBancarios: null,
    idBanco: "",
    idTipoCuenta: "",
    cbu: "",
    alias: "",
    idPlazoPago: "",
    idPlazoDebito: "",
    idCategoriaEfector: "",
    idCategoriaEfector1: "",
    idCategoriaEfector2: "",
    idCategoriaEfector3: "",
    idCategoriaEfector4: "",
    idCategoriaEfector5: "",
    plazoRecepcionFacturas: 10,
    formaPago: "",
    idIva: "",

    plazoPago: "", // reemplaza idPlazoPago 
    plazoDebito: "", // reemplaza idPlazoDebito
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    datosContablesExistentes !== null
      ? { ...datosContablesExistentes, judicial: dataCuentaJudicial() }
      : { ...datosContablesNuevos, judicial: dataCuentaJudicial() }
  );

  const {
    idBanco,
    idTipoCuenta,
    cbu,
    alias,
    idCategoriaEfector1,
    idCategoriaEfector2,
    idCategoriaEfector3,
    idCategoriaEfector4,
    idCategoriaEfector5,
    plazoRecepcionFacturas,
    formaPago,
    idIva,
    idPlazoPago,
    idPlazoDebito,
    judicial
  } = formValues;

  const handleAliasChange = (e) => {
    let reg = new RegExp("^[a-z A-Z 0-9 . -]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      if (reg.test(e.target.value) === 0) {
        setearValor("alias", "");
      } else {
        setearValor("alias", e.target.value);
      }
    }
  };

  let categoriasMostrar1 = listaCategorias.filter(
    (categoria) => categoria.idCategoriaPadre === null
  );
  let categoriasMostrar2 = [];
  let categoriasMostrar3 = [];
  let categoriasMostrar4 = [];
  let categoriasMostrar5 = [];

  if (idCategoriaEfector1 !== null && idCategoriaEfector1 !== "") {
    categoriasMostrar2 = listaCategorias.filter(
      (categoria) => categoria.idCategoriaPadre === idCategoriaEfector1
    );
  }

  if (idCategoriaEfector2 !== null && idCategoriaEfector2 !== "") {
    categoriasMostrar3 = listaCategorias.filter(
      (categoria) => categoria.idCategoriaPadre === idCategoriaEfector2
    );
  }

  if (idCategoriaEfector3 !== null && idCategoriaEfector3 !== "") {
    categoriasMostrar4 = listaCategorias.filter(
      (categoria) => categoria.idCategoriaPadre === idCategoriaEfector3
    );
  }

  if (idCategoriaEfector4 !== null && idCategoriaEfector4 !== "") {
    categoriasMostrar5 = listaCategorias.filter(
      (categoria) => categoria.idCategoriaPadre === idCategoriaEfector4
    );
  }

  const submitHandler = (e) => {
    e.preventDefault();
    const { judicial, ...data } = formValues;
    if (props.tieneSubAreaLegales && cuentaJudicial) dispatch(guardarDatosJudiciales(judicial, (values) => setearVariosValores({
      ...formValues,
      judicial: dataCuentaJudicial(values)
    })));
    else if (validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTABLES_PERMISOS.ADMINISTRAR) && props.menu !== MENU_CONTRATACIONES.CONSULTA)
      dispatch(guardarDatosContables(data));
  };

  useEffect(() => {
    if (listaBancos?.length === 0) {
      dispatch(fetchBancos());
    }
    if (listaCategorias?.length === 0) {
      dispatch(fetchCategoriasEfectores());
    }
    if (listaIva?.length === 0) {
      dispatch(fetchCondicionIva());
    }
    // eslint-disable-next-line
  }, [dispatch, listaBancos, listaCategorias]);

  useEffect(() => {
    if (idCategoriaEfector5 !== null && idCategoriaEfector5 !== "") {
      setearValor("idCategoriaEfector", idCategoriaEfector5);
    } else if (idCategoriaEfector4 !== null && idCategoriaEfector4 !== "") {
      setearValor("idCategoriaEfector", idCategoriaEfector4);
    } else if (idCategoriaEfector3 !== null && idCategoriaEfector3 !== "") {
      setearValor("idCategoriaEfector", idCategoriaEfector3);
    } else if (idCategoriaEfector2 !== null && idCategoriaEfector2 !== "") {
      setearValor("idCategoriaEfector", idCategoriaEfector2);
    } else {
      setearValor("idCategoriaEfector", idCategoriaEfector1);
    }
    // eslint-disable-next-line
  }, [
    idCategoriaEfector1,
    idCategoriaEfector2,
    idCategoriaEfector3,
    idCategoriaEfector4,
    idCategoriaEfector5,
  ]);

  useEffect(() => {
    dispatch(obtenerDatosContables());
    dispatch(obtenerDatosJudiciales((data) => setearVariosValores({
      ...formValues,
      judicial: dataCuentaJudicial(data)
    })));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (datosContablesExistentes === null) {
      if (dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS) {
        setearVariosValores({
          ...datosContablesNuevos,
          idCategoriaEfector1: CATEGORIAS_EFECTOR.GASTO_ASISTENCIAL,
          idCategoriaEfector2: CATEGORIAS_EFECTOR.PRESTADOR,
          idCategoriaEfector3: CATEGORIAS_EFECTOR.HONORARIOS_MCP
        });
      } else {
        setearVariosValores(datosContablesNuevos);
      }
    } else {
      setearVariosValores(datosContablesExistentes);
    }
    // eslint-disable-next-line
  }, [dispatch, datosContablesExistentes]);


  //PLAZO PAGO
  const { items } = useSelector((state) => state.listaPlazos)

  useEffect(() => {
    dispatch(FetchPlazos());
  }, [dispatch]);

  const listaPPFiltrada = items.filter(objeto => objeto.descripcionTipoPlazo === "Plazo Pago")
  const listaPDFiltrada = items.filter(objeto => objeto.descripcionTipoPlazo === "Plazo Debito")

  return (
    <div style={{ margin: "1.5em" }}>
      <ValidatorForm onSubmit={submitHandler}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6">Datos Bancarios:</Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="Banco"
                  name="idBanco"
                  value={idBanco}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={["required"]}
                  errorMessages={["Seleccione un banco"]}
                >
                  {listaBancos.map((banco) => (
                    <MenuItem
                      key={banco.idNominaBancos}
                      value={banco.idNominaBancos}
                    >
                      {banco.nombre}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="Tipo de Cuenta"
                  name="idTipoCuenta"
                  value={idTipoCuenta}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={["required"]}
                  errorMessages={["Seleccione un Tipo de Cuenta"]}
                >
                  <MenuItem value={1}>Cuenta Corriente</MenuItem>
                  <MenuItem value={2}>Caja de Ahorro</MenuItem>
                </SelectValidator>
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="normal"
                  label="CBU"
                  name="cbu"
                  value={cbu || ""}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={
                    formaPago === 3
                      ? ["required", "isNumber", 'minStringLength:22', 'maxStringLength:22']
                      : cbu.length > 0
                        ? ['minStringLength:22', 'maxStringLength:22']
                        : []
                  }
                  errorMessages={
                    formaPago === 3
                      ? ["CBU requerido", "Sólo números", "Máximo 22 dígitos. Verifique CBU", "Debe contener 22 dígitos"]
                      : cbu.length > 0
                        ? ["Máximo 22 dígitos. Verifique CBU", "Debe contener 22 dígitos"]
                        : []
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="normal"
                  label="Alias"
                  name="alias"
                  value={alias}
                  onChange={handleAliasChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                // inputProps={{
                //   maxLength: 22
                // }}
                // validators={["required"]}
                // errorMessages={["Alias requerido"]}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="Plazo Pago"
                  name="idPlazoPago"
                  value={idPlazoPago}
                  onChange={(e) => {
                    setearVariosValores({
                      plazoPago: listaPPFiltrada.find((p) =>
                        p.id === e.target.value).dias,
                      idPlazoPago: e.target.value
                    })
                  }}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={props.subTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR ? ["required"] : []}
                  errorMessages={props.subTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR ? ["Seleccione plazo débito"] : []}
                >
                  <MenuItem value={0}>
                    <em>Seleccione Plazo</em>
                  </MenuItem>
                  {
                    listaPPFiltrada.map((pla) => (
                      <MenuItem key={pla.id} value={pla.id}>
                        {pla.dias === 0 ? "PRONTO PAGO" : pla.dias}
                      </MenuItem>
                    ))

                  }
                </SelectValidator>
              </Grid>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="Plazo Débitos"
                  name="idPlazoDebito"
                  value={idPlazoDebito}
                  onChange={(e) =>
                    setearVariosValores({
                      plazoDebito: listaPDFiltrada.find((p) =>
                        p.id === e.target.value).dias,
                      idPlazoDebito: e.target.value
                    })
                  }
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={props.subTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR ? ["required"] : []}
                  errorMessages={props.subTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR ? ["Seleccione plazo débito"] : []}
                >
                  <MenuItem value={0}>
                    <em>Seleccione Plazo</em>
                  </MenuItem>
                  {
                    listaPDFiltrada.map((pla) => (
                      <MenuItem key={pla.id} value={pla.id}>
                        {pla.dias === 0 ? "PRONTO PAGO" : pla.dias}
                      </MenuItem>
                    ))

                  }
                </SelectValidator>
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="normal"
                  label="Plazo de Recepcion de Facturas"
                  name="plazoRecepcionFacturas"
                  value={plazoRecepcionFacturas}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  type="number"
                  validators={["isNumber"]}
                  errorMessages={["Solo numeros"]}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="Forma de Pago"
                  name="formaPago"
                  value={formaPago}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={["required"]}
                  errorMessages={["Seleccione una Forma de Pago"]}
                >
                  <MenuItem value={1}>Efectivo</MenuItem>
                  <MenuItem value={2}>Cheque</MenuItem>
                  <MenuItem value={3}>Transferencia</MenuItem>
                </SelectValidator>
              </Grid>
              <Grid item xs={6}>
                <SelectValidator
                  margin="normal"
                  fullWidth
                  label="IVA"
                  name="idIva"
                  value={idIva}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={["required"]}
                  errorMessages={["Seleccione un IVA"]}
                >
                  {listaIva.map((iva) => (
                    <MenuItem
                      key={iva.id}
                      value={iva.id}
                    >
                      {iva.descripcion}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">Categorías administrativas:</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <SelectValidator
                      fullWidth
                      margin="normal"
                      label="Primer Categoria"
                      name="idCategoriaEfector1"
                      value={idCategoriaEfector1}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                      validators={["required"]}
                      errorMessages={["Seleccione una Primer Categoria"]}
                    >
                      {categoriasMostrar1.map((categoria) => {
                        return (
                          <MenuItem value={categoria.idCategoriaEfector}>
                            {categoria.descripcion}
                          </MenuItem>
                        );
                      })}
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <SelectValidator
                      fullWidth
                      margin="normal"
                      label="Segunda Categoria"
                      name="idCategoriaEfector2"
                      value={idCategoriaEfector2}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    >
                      {categoriasMostrar2.map((categoria) => {
                        return (
                          <MenuItem value={categoria.idCategoriaEfector}>
                            {categoria.descripcion}
                          </MenuItem>
                        );
                      })}
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <SelectValidator
                      fullWidth
                      margin="normal"
                      label="Tercera Categoria"
                      name="idCategoriaEfector3"
                      value={idCategoriaEfector3}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    >
                      {categoriasMostrar3.map((categoria) => {
                        return (
                          <MenuItem value={categoria.idCategoriaEfector}>
                            {categoria.descripcion}
                          </MenuItem>
                        );
                      })}
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <SelectValidator
                      margin="normal"
                      fullWidth
                      label="Cuarta Categoria"
                      name="idCategoriaEfector4"
                      value={idCategoriaEfector4}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    >
                      {categoriasMostrar4.map((categoria) => {
                        return (
                          <MenuItem value={categoria.idCategoriaEfector}>
                            {categoria.descripcion}
                          </MenuItem>
                        );
                      })}
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <SelectValidator
                      fullWidth
                      margin="normal"
                      label="Quinta Categoria"
                      name="idCategoriaEfector5"
                      value={idCategoriaEfector5}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    >
                      {categoriasMostrar5.map((categoria) => {
                        return (
                          <MenuItem value={categoria.idCategoriaEfector}>
                            {categoria.descripcion}
                          </MenuItem>
                        );
                      })}
                    </SelectValidator>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Cuenta Judicial:</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <SelectValidator
                      margin="normal"
                      fullWidth
                      label="Banco"
                      name="judicial.idBanco"
                      value={judicial.idBanco}
                      onChange={handleInputChange}
                      validators={cuentaJudicial ? ["required"] : []}
                      errorMessages={cuentaJudicial ? ["Seleccione un banco"] : []}
                      disabled={!props.tieneSubAreaLegales || !cuentaJudicial}
                    >
                      {listaBancos.map((banco) => (
                        <MenuItem
                          key={banco.idNominaBancos}
                          value={banco.idNominaBancos}
                        >
                          {banco.nombre}
                        </MenuItem>
                      ))}
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <SelectValidator
                      margin="normal"
                      fullWidth
                      label="Tipo de Cuenta"
                      name="judicial.idTipoCuenta"
                      value={judicial.idTipoCuenta}
                      onChange={handleInputChange}
                      validators={cuentaJudicial ? ["required"] : []}
                      errorMessages={cuentaJudicial ? ["Seleccione un Tipo de Cuenta"] : []}
                      disabled={!props.tieneSubAreaLegales || !cuentaJudicial}
                    >
                      <MenuItem value={1}>Cuenta Corriente</MenuItem>
                      <MenuItem value={2}>Caja de Ahorro</MenuItem>
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={6}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      label="CBU"
                      name="judicial.cbu"
                      value={judicial.cbu || ""}
                      onChange={handleInputChange}
                      disabled={!props.tieneSubAreaLegales || !cuentaJudicial}
                      validators={cuentaJudicial ? (
                        formaPago === 3
                          ? ["required", "isNumber", 'minStringLength:22', 'maxStringLength:22']
                          : cbu.length > 0
                            ? ['minStringLength:22', 'maxStringLength:22']
                            : []) : []
                      }
                      errorMessages={cuentaJudicial ? (
                        formaPago === 3
                          ? ["CBU requerido", "Sólo números", "Máximo 22 dígitos. Verifique CBU", "Debe contener 22 dígitos"]
                          : cbu.length > 0
                            ? ["Máximo 22 dígitos. Verifique CBU", "Debe contener 22 dígitos"]
                            : []
                      ) : []
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      label="Alias"
                      name="judicial.alias"
                      value={judicial.alias}
                      disabled={!props.tieneSubAreaLegales || !cuentaJudicial}
                      onChange={(e) => {
                        let reg = new RegExp("^[a-z A-Z 0-9 . -]+$");
                        if (e.target.value === "" || reg.test(e.target.value)) {
                          if (reg.test(e.target.value) === 0) {
                            setearValor("judicial.alias", "");
                          } else {
                            setearValor("judicial.alias", e.target.value);
                          }
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTABLES_PERMISOS.ADMINISTRAR) &&
          (props.menu !== MENU_CONTRATACIONES.CONSULTA || cuentaJudicial) && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<Save />}
              >
                Guardar datos
              </Button>
            </div>
          )}
      </ValidatorForm>
    </div>
  );
};
